import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { SharedStyles } from '@shared/styles';
import { MBImage } from './MBImage';
import {
  MBIconV2Name,
  MBIconV2NameMap,
  REMAPPED_ICON_NAMES,
  REMAPPED_ICON_SCALE,
} from './iconV2Map';
import { Styles } from './styles';
import classNames from './iconV2.module.css';

export interface MBIconV2Props {
  color?: string;
  name?: MBIconV2Name;
  size?: number;
  style?: StyleProp<ViewStyle>;
  className?: ClassValue;
  testID?: string;
}

export function MBIconV2({ name, color, size, style, className, testID }: MBIconV2Props) {
  const icon = !isNil(name) && MBIconV2NameMap[name];
  if (!icon) {
    return null;
  }

  const scale = !isNil(name) && REMAPPED_ICON_NAMES.has(name) ? REMAPPED_ICON_SCALE : null;
  const imageStyle = scale
    ? [SharedStyles.full, { transform: [{ scale }] } as ViewStyle]
    : SharedStyles.full;

  if (isNil(style)) {
    return (
      <View
        className={[classNames.iconv2, className]}
        vars={{ size }}
        style={scale ? { overflow: 'hidden' } : undefined}
        testID={testID}
      >
        <MBImage style={imageStyle} resizeMode="contain" source={icon} tintColor={color} />
      </View>
    );
  } else {
    return (
      <MBView
        style={[
          Styles.iconv2,
          !!size && { width: size, height: size },
          !!scale && { overflow: 'hidden' },
          style,
        ]}
        testID={testID}
      >
        <MBImage style={imageStyle} resizeMode="contain" source={icon} tintColor={color} />
      </MBView>
    );
  }
}
